<script lang="ts" setup>
import { useUserStore } from '@/store/user/user'

const AppProgress = defineAsyncComponent(
  () => import('@/components/App/AppProgress.vue'),
)

const { isAuthenticated: isAuth } = useUserStore()
const { query } = useRoute()
const { isMobileOrTablet, isDesktop } = useDevice()

const isLoading = ref(true)

usePopupFetch()

onMounted(() => {
  if (isAuth) {
    window.location.replace('/')
  }

  isLoading.value = false
})

const isAuthenticated = computed(() => isAuth)
const signInRedirectPath = computed(() => query.backUrl || '/')
</script>

<template>
  <div>
    <app-head title="Вход в личный кабинет" />

    <app-progress v-if="isLoading && !isAuthenticated" page />

    <div
      v-else
      class="login-page"
      :class="{ 'login-page--desktop': isDesktop }"
    >
      <nuxt-link v-if="isMobileOrTablet" to="/" class="login-page__logo-link">
        <nuxt-img class="login-page__logo" src="/logo.svg" alt="Логотип" />
      </nuxt-link>

      <login-form :sign-in-redirect-path="signInRedirectPath" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-page {
  &--desktop {
    padding-top: 100px;
    padding-bottom: 246px;
  }

  &__logo-link {
    display: block;
    width: max-content;
    margin: auto;
    margin-bottom: 36px;
  }

  &__logo {
    width: 110px;
  }
}
</style>
